module.exports = __webpack_public_path__ + "static/media/049-tooth.4449ee07.svg";